import curd from '../curd'

const BASE_PATH = '/factor/group'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/FactorGroup.js